import { Space, Button, Popconfirm } from "antd";
import {
  EditOutlined,
  PlusOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "Store/hooks";
import { IPaddleProduct } from "../../redux/types";
import { setErrorState } from "Components/Basic/ErrorBoundary/redux/slice";
import { archivePaddleProduct, getAllPaddleProducts } from "../../redux/thunks";

interface ActionRendererProps {
  record: IPaddleProduct;
}

export const ActionRenderer = ({ record }: ActionRendererProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/payment-products/edit/${record.productId}`);
  };

  const handleAddPrice = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/payment-products/${record.productId}/add-price`);
  };

  const handleViewPrices = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/payment-products/${record.productId}/prices`);
  };

  const handleDelete = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await dispatch(archivePaddleProduct(record.productId)).unwrap();
      dispatch(
        setErrorState({
          message: "Success",
          description: "Product archived successfully",
          placement: "topRight",
          type: "success",
        })
      );
      // Refresh the product list to reflect the archived product removal
      await dispatch(getAllPaddleProducts()).unwrap();
    } catch (error: any) {
      dispatch(
        setErrorState({
          message: "Error",
          description: error.message || "Failed to archive product",
          placement: "topRight",
          type: "error",
        })
      );
    }
  };

  return (
    <Space size="middle">
      <Button
        type="link"
        icon={<PlusOutlined />}
        onClick={handleAddPrice}
        title="Add Price"
      >
        Add Price
      </Button>
      <Button
        type="link"
        icon={<EyeOutlined />}
        onClick={handleViewPrices}
        title="View Prices"
      >
        View Prices
      </Button>
      <Button
        type="link"
        icon={<EditOutlined />}
        onClick={handleEdit}
        title="Edit Product"
      >
        Edit
      </Button>
      <Popconfirm
        title="Delete Product"
        description="Are you sure you want to delete this product? This action cannot be undone."
        onConfirm={(e) => {
          if (e) {
            e.stopPropagation();
          }
          handleDelete(e as React.MouseEvent);
        }}
        onCancel={(e) => {
          if (e) {
            e.stopPropagation();
          }
        }}
        okText="Yes"
        cancelText="No"
      >
        <Button
          type="link"
          danger
          icon={<DeleteOutlined />}
          title="Delete Product"
          onClick={(e) => e.stopPropagation()}
        >
          Delete
        </Button>
      </Popconfirm>
    </Space>
  );
};
